import type { SVGProps } from 'react';

const SvgArrowLeftLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M4 12H20' stroke='currentColor' strokeMiterlimit={10} strokeLinecap='round' />
    <path d='M10 6L4 12L10 18' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgArrowLeftLt;
